/* eslint-disable import/prefer-default-export */
import type { ProductReviewListModel } from 'autogen/swagger/all';
import type IOption from 'components/shared/inputs/select/shared/types/option';

const arrayOfAllSortBys = <T extends ProductReviewListModel['sortBy'][]>(
    array: T & ([ProductReviewListModel['sortBy']] extends [T[number]] ? unknown : 'Invalid')
) => array;

export function getSortOptions(sortTranslations: any): IOption[] {
    const sortOptions: IOption[] = [];
    const sortBy: ProductReviewListModel['sortBy'][] = arrayOfAllSortBys([
        'LatestReviewed',
        'MostLiked',
        'EarliestReviewed',
        'HighestRating',
        'LowestRating'
    ]);

    sortBy.forEach((entry) => {
        sortOptions.push({
            value: entry,
            label: sortTranslations[entry.toString()]
        });
    });

    return sortOptions;
}
